<template>
  <div class="col-span-1 flex flex-col gap-y-6 sm:col-span-2">
    <div
      class="grid w-full grid-cols-4 items-center sm:grid-cols-8"
      v-for="(location, index) in data.product.locations"
      :key="location.id || location.tempId"
    >
      <InputLocation
        :value="location"
        @update:value="
          (newVal) => updateLocation(location.id || location.tempId, newVal)
        "
        :label-country="__('Country')"
        :label-city="__('City')"
        :placeholder-country="__('Add country')"
        :placeholder-city="__('Add city')"
        :options="data.options.countries"
        class="col-span-3 sm:col-span-7"
        :errors="errors?.[`locations.${index}.country.id`]"
      >
      </InputLocation>
      <div class="flex h-full items-center sm:items-end">
        <button
          v-if="data.product.locations.length > 1"
          class="btn btn-ghost-no-hover gap-x-1.5"
          @click="handleDeleteLocation(location, index)"
        >
          <Icon type="filled" class="text-xl text-primary" name="delete" />
          <span>{{ __('Delete ') }}</span>
        </button>
      </div>
    </div>

    <button
      @click="
        data.product.locations.push({ tempId: Date.now() + Math.random() })
      "
      class="btn btn-ghost flex flex-row items-center gap-x-1.5 px-4"
    >
      <Icon type="filled" name="add_box" class="text-xl"></Icon>
      <span class="text-primary"> {{ __('Add another country') }}</span>
    </button>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import { useToast } from 'vue-toastification';
  import { __ } from '@/helpers';
  import InputLocation from '@/components/form/input-location/input-location.vue';
  import Icon from '@/components/global/Icon.vue';

  const props = defineProps({
    data: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  });

  const handleDeleteLocation = (location, location_index) => {
    if (props.data.product.deleted_locations_ids === undefined)
      props.data.product.deleted_locations_ids = [];

    if (location.id) props.data.product.deleted_locations_ids.push(location.id);

    props.data.product.locations.splice(location_index, 1);
  };

  const updateLocation = (locationId, newValue) => {
    const index_id = props.data.product.locations.findIndex(
      (loc) => loc.id === locationId
    );

    const index_tempId = props.data.product.locations.findIndex(
      (loc) => loc.tempId === locationId
    );

    if (index_id !== -1) {
      props.data.product.locations[index_id] = { ...newValue, id: locationId };
    } else if (index_tempId !== -1) {
      props.data.product.locations[index_tempId] = {
        ...newValue,
        tempId: locationId
      };
    }
  };
</script>
